var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-rich-text",class:{ 'app-rich-text--compact': _vm.compact },domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})
}
var staticRenderFns = []

export { render, staticRenderFns }